import { hasSourceGameMeta } from '../common/SourceGameHeader';
import type {
  CardSource,
  PositionReviewCard,
  ReviewCardDto,
} from './types';

/** User-facing origin of a due SRS card, reflected in the review URL. */
export type ReviewCardUrlSource =
  | 'puzzle'
  | 'replay'
  | 'lesson'
  | 'line'
  | 'manual'
  | 'auto';

export function reviewCardUrlSource(card: ReviewCardDto): ReviewCardUrlSource {
  if (card.kind === 'puzzle') {
    return 'puzzle';
  }
  return positionCardUrlSource(card);
}

function positionCardUrlSource(card: PositionReviewCard): ReviewCardUrlSource {
  const source: CardSource = card.source ?? 'auto';
  const hasGame = hasSourceGameMeta(card);

  if (source === 'manual') {
    return 'manual';
  }
  if (source === 'line') {
    return hasGame ? 'lesson' : 'line';
  }
  return hasGame ? 'replay' : 'auto';
}
